'use client';

/**
 * Unilevel Plan - Custom Layout
 * All components are specific to this plan only, kept in this folder.
 */

import { PlanIntroSection } from '../common/plan-intro-section';
import { FeaturesSection } from '../common/features-section';
import { WhySoftwareSection } from '../common/why-software-section';
import { HowSoftwareWorksSection } from '../common/how-software-works-section';
import { WhatIsSoftwareSection } from '../common/what-is-software-section';
import { CommissionsSection } from '../common/commissions-section';
import { AdvantagesSection } from './AdvantagesSection';
import { WhatIsPlanSection } from './WhatIsPlanSection';
import { HowItWorksSection } from './HowItWorksSection';
import { UserPlus, Layers, Zap, Award } from 'lucide-react';

interface MLMPlan {
    slug: string;
    name: string;
    description: string;
    content: string;
    image?: string;
    features?: string[];
}

interface PlanDetailContentProps {
    plan: MLMPlan;
}

export default function PlanDetailContent({ plan }: PlanDetailContentProps) {
    return (
        <div className="min-h-screen bg-white dark:bg-gray-950">
            <PlanIntroSection
                plan={plan}
                translationNamespace="planDetails.unilevelPlan.hero"
                imageSrc="/images/mlm-plans/Unilevel_tree.gif"
                descriptionKeys={['description1', 'description2']}
            />
            <WhatIsPlanSection plan={plan} />
            <HowItWorksSection plan={plan} />
            <WhatIsSoftwareSection
                plan={plan}
                translationNamespace="planDetails.unilevelPlan.whatIsSoftware"
                imageSrc="/images/mlm-plans/mlm-software-demo.webp"
            />
            <HowSoftwareWorksSection plan={plan} translationNamespace="planDetails.unilevelPlan.howSoftwareWorks" />
            <FeaturesSection plan={plan} translationNamespace="planDetails.unilevelPlan.features" />
            <AdvantagesSection
                plan={plan}
                translationNamespace="planDetails.unilevelPlan.advantages"
                advantageKeys={['advantage1', 'advantage2', 'advantage3', 'advantage4', 'advantage5', 'advantage6', 'advantage7', 'advantage8']}
            />
            <CommissionsSection
                plan={plan}
                translationNamespace="planDetails.unilevelPlan.commissions"
                commissions={[
                    { icon: UserPlus, color: 'primary', titleKey: 'referral.title', descriptionKey: 'referral.description' },
                    { icon: Layers, color: 'blue', titleKey: 'level.title', descriptionKey: 'level.description' },
                    { icon: Zap, color: 'green', titleKey: 'fastStart.title', descriptionKey: 'fastStart.description' },
                    { icon: Award, color: 'purple', titleKey: 'pool.title', descriptionKey: 'pool.description' },
                ]}
                gridCols="4"
            />
            <WhySoftwareSection plan={plan} translationNamespace="planDetails.unilevelPlan.whySoftware" />
        </div>
    );
}

